import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

const fetcher = (url, params) => api.get(url, { params }).then((r) => r.data);

export const useHomeData = () => useQuery({ queryKey: ["home"], queryFn: () => fetcher("/home") });

export const useCategories = () =>
  useQuery({ queryKey: ["categories"], queryFn: () => fetcher("/categories"), staleTime: 300_000 });

export const useProducts = (params) =>
  useQuery({ queryKey: ["products", params], queryFn: () => fetcher("/products", params) });

export const useProduct = (slug) =>
  useQuery({ queryKey: ["product", slug], queryFn: () => fetcher(`/products/${slug}`), enabled: !!slug });

export const useFacets = (category) =>
  useQuery({ queryKey: ["facets", category], queryFn: () => fetcher("/products/facets", { category }) });

export const useFaq = () => useQuery({ queryKey: ["faq"], queryFn: () => fetcher("/faq"), staleTime: 300_000 });

export const useServices = () =>
  useQuery({ queryKey: ["services"], queryFn: () => fetcher("/services"), staleTime: 300_000 });

export const usePaymentMethods = () =>
  useQuery({ queryKey: ["payment-methods"], queryFn: () => fetcher("/payment-methods"), staleTime: 300_000 });

export const useSupportContacts = () =>
  useQuery({ queryKey: ["support-contacts"], queryFn: () => fetcher("/support/contacts"), staleTime: 300_000 });

export const useShops = () =>
  useQuery({ queryKey: ["shops"], queryFn: () => fetcher("/shops"), staleTime: 120_000 });
